<order-generic-container headerKey="CHOOSE_PRODUCT_PARENT" *ngIf="products">
    <product-info [products]="products" [isOrderPage]="true"></product-info>
</order-generic-container>